
import * as React from 'react'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import { Typography } from '@mui/material'

export function formatDate (lastUpdated: string, short: boolean = false): string {
  if (lastUpdated === undefined || lastUpdated?.length === 0) {
    return 'Not available'
  }

  const date = new Date(lastUpdated)
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: short ? 'short' : 'long', day: 'numeric' }
  return new Intl.DateTimeFormat('en-US', options).format(date)
}

interface LastUpdatedProps {
  value?: string
  label?: string
}
const LastUpdatedComponent: React.FC<LastUpdatedProps> = (props: LastUpdatedProps): JSX.Element => {
  const formattedDate = formatDate(props?.value ?? '')

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <AccessTimeIcon />
      <Typography variant="caption" style={{ marginLeft: '4px' }}>{`${props.label ?? 'Last Updated'}: ${formattedDate}`}</Typography>
    </div>
  )
}

export default LastUpdatedComponent
